import { useQuery } from "react-query";
import { USERS } from "helpers/constants";
import { UserAPI } from "api/user";

export default function useUsers(filter) {
  return useQuery([USERS, filter], () => UserAPI.getUsers(filter));
}
